import React from 'react';
import AgencySettingsModule from '../modules/AgencySettingsModule.js';
import './Box.css';

const AgencySettingsBox = ({ user, isSmallScreen, testSections }) => {
    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>

            {/* <h1 className='box-title'> Agency Settings </h1> */}
            <h4></h4>
            
            <AgencySettingsModule 
                user={user}
                isSmallScreen={isSmallScreen}
                testSections={testSections}
            />
        </div>
    );
};

export default AgencySettingsBox; 